import { useNavigate, useLocation } from "react-router-dom";
import { FaAnglesLeft } from "react-icons/fa6";
import { YearDD } from "../../ReusableComponents/CommonApis";
import { AssessmentNameDates } from "../../ReusableComponents/CommonComponents";
const NCLAdminSubMenu = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    return (
        <>
            {
                // !props.CheckPath("/SamagraDashboard") && !props.CheckPath("/OMRResults") &&  !props.CheckPath("/NCLAdmin") &&!
                ( props.CheckPath("/EmailDeliveryStatus") || props.CheckPath("/OMRResults") || props.CheckPath("/NCLAdmin/AssessmentParticipation") || props.YearH ||
                props.CheckPath("/NCLAdmin/StudentResponses") || props.CheckPath("/NCLAdmin/Schools/BulkUpload")
 ) &&

                <div className="Sub-Header">
                    <div className="dflex JSBetween pb-2" style={{ alignItems: "flex-start" }}>
                        {
                            props.CheckPath("/NCLAdmin/Schools/BulkUpload")
                                ? (
                                    <button className="BackNavigation Buttons dflex alignitems JCCenter gap-1" onClick={() => navigate(-1)} > <FaAnglesLeft /> Back </button>
                                ) : (
                                    <div></div>
                                )
                        }
                        <AssessmentNameDates Path={location.pathname} />
                        {
                            !props.CheckPath("/StudentDetails") &&
                            !props.CheckPath("/InstitutionMaster") && !props.CheckPath("/Schools") &&
                            !props.CheckPath("/QBAdminLogin") && !props.CheckPath("/StudentDetails") &&
                            (
                                <div className="" style={{ justifyContent: "end" }}>
                                    {
                                        !props.CheckPath("/InstitutionMaster") &&
                                        !props.CheckPath("/Schools") && !props.CheckPath("/QBReports") &&
                                        !props.CheckPath("/AssessmentParameters") && !props.CheckPath("/WeeklyTests") &&
                                        !props.CheckPath("/AddTest") && !props.CheckPath("/AssessmentQuestionPaper") &&
                                        !props.YearH &&
                                        (
                                            <YearDD />
                                        )
                                    }
                                </div>
                            )
                        }
                    </div>
                </div>
            }
        </>
    )
}
export default NCLAdminSubMenu;